export default function Icon({
  icon,
  character,
  size = "regular",
  button = false,
  animate = false,
  iconColor,
  pagination = false,
}) {
  const className = `icon ${animate ? "icon--animate" : ""} ${
    character ? "icon--character" : ""
  } ${iconColor === "light" ? "icon--light" : ""}`;

  return (
    <span
      className={className}
      {...(character ? {} : { "data-icon": icon })}
      data-size={size}
    >
      {character && (
        <span className="character">
          <p
            className={`${size === "regular" ? "label--size-s" : ""} ${
              pagination ? "pagination" : ""
            }`}
          >
            {character}
          </p>
        </span>
      )}
      {animate && <div className="icon-inner"></div>}
    </span>
  );
}
